module.exports = __webpack_public_path__ + "static/media/rsrcmtr_125.e4be55c9.ico";